import { useState, useEffect, useCallback, useRef } from "react";
import styles from "../../../pages/ordermanager/Orders.module.css";
import fetchData from "../../../APIsControll/apiControll";
import SearchItem from "./SearchItem";
import { useToast } from "../Toaster/Toaster";
import { RemoveIcon } from "../../icons/Icon";

const ProductionSaleNewItemList = ({
  mode,
  index,
  item,
  itemInpRefs,
  onItemChange,
  onRemove,
  itemDetailsLength,
  onAddNewItem,
  quantityRefs,
  setShowItemSearch,
  itemFocus,
  itemBlur,
  focusedItemIndex,
  showItemSearch,
  onShowDesc,
  onCompletion,
  flag,
  allItems,
  setGeneralInfo,
  setDispatchWarehouse,
  generalInfo,
}) => {
  const { show } = useToast();

  // console.log();

  const descInpRef = useRef(null);
  const inputRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showDescInput, setShowDescInput] = useState(false);

  // ── Sync description with item.desc so it stays correct after
  //    parent resets or when the same component instance is reused ──────────
  const [description, setDescription] = useState(item.desc || "");

  useEffect(() => {
    setDescription(item.desc || "");
  }, [item.desc]);
  // ─────────────────────────────────────────────────────────────────────────

  const [selectedItem, setSelectedItem] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  useEffect(() => {
    const firstItem = allItems?.[0];

    if (!firstItem?.warehouseId) return;

    setGeneralInfo((prev) => ({
      ...prev,
      warehouseId: firstItem.warehouseId,
      warehousename: firstItem.warehouse,
    }));

    setDispatchWarehouse({
      label: firstItem.warehouse,
      value: firstItem.warehouseId,
    });
  }, [allItems]);

  // for same Warehouse section get first index warehouse Id
  // const firstWarehouseId = allItems?.[0]?.warehouseId;

  const firstWarehouseId =
    flag === "create" ? allItems?.[0]?.warehouseId : generalInfo?.warehouseId;

  // const warehouseName =
  //   flag === "create" ? allItems?.[0]?.warehouse : generalInfo?.warehousename;
  // console.log(firstWarehouseId); // 1

  const fetchItems = useCallback(async () => {
    const apiData = {
      managerId: 1,
      voucherType: "",
      keyword: item.itemNo,
      warehouseId: firstWarehouseId || "",
    };

    try {
      setLoading(true);
      const result = await fetchData("order/prodAndSaleSearchItems", apiData);
      if (result.status === "success") {
        setResults(result.data || []);
        setCurrentIndex(0);
      }
    } catch (error) {
      console.error("Search error:", error);
      setResults([]);
    } finally {
      setLoading(false);
    }
  }, [item.itemNo]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    if (value?.length < item?.itemNo?.length) {
      setSelectedItem(null);
    }
    onItemChange("itemNo", value);
    setShowItemSearch(value?.length > 2);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();

      if (e.target.value === "") {
        if (itemDetailsLength > 1) {
          onCompletion && onCompletion();
          onRemove(index);
        } else {
          show(
            "YOU CANNOT ADD NEW ITEM BEFORE FILLING THE CURRENT ONE!",
            "warning",
          );
        }
        return;
      }

      if (showItemSearch) {
        if (results?.length > 0 && currentIndex >= 0) {
          const selected = results[currentIndex];
          if (validateItem(selected)) {
            setSelectedItem(selected);
            setShowItemSearch(false);
            handleItemSelect(selected);
            setTimeout(() => {
              quantityRefs.current[index]?.focus();
            }, 50);
          }
        } else {
          inputRef.current?.blur();
          setShowItemSearch(false);
        }
      } else {
        setTimeout(() => {
          quantityRefs.current[index]?.focus();
        }, 50);
      }
    } else if (e.key === "ArrowDown") {
      if (showItemSearch) {
        e.preventDefault();
        setCurrentIndex((prev) => Math.min(prev + 1, results?.length - 1));
      }
    } else if (e.key === "ArrowUp") {
      if (showItemSearch) {
        e.preventDefault();
        setCurrentIndex((prev) => Math.max(prev - 1, 0));
      }
    }
  };

  const validateItem = useCallback(
    (selectedItem) => {
      const warnings = [];
      if (selectedItem?.vm === null || selectedItem?.weight === null) {
        warnings.push("Either weight or volume is not added to this item!");
        show(warnings, "warning");
        return false;
      }

      if (!selectedItem?.price || selectedItem?.dp === 0) {
        warnings.push("Price is not assigned to this item!");
        show(warnings, "warning");
        return false;
      }

      if (selectedItem?.unit === "") {
        warnings.push("Unit is not assigned to this item!");
        show(warnings, "warning");
        return false;
      }

      if (selectedItem?.outsourcedItem === "Disable") {
        if (selectedItem?.totalQty <= 0) {
          warnings.push("Item is out of stock!");
          show(warnings, "warning");
          return false;
        }
      }

      return true;
    },
    [show],
  );

  const handleItemSelect = useCallback(
    (selectedItem) => {
      onItemChange("product_name", selectedItem?.product_name);
      onItemChange("collection_name", selectedItem?.collection_name);
      onItemChange("warehouse", selectedItem?.warehouse);
      onItemChange("warehouseId", selectedItem?.warehouseId);
      onItemChange("price", selectedItem?.price);
      onItemChange("unit", selectedItem?.unit);
      onItemChange("itemNo", selectedItem?.itemNo);
      onItemChange("dp", selectedItem?.dp);
      onItemChange("vm", selectedItem?.vm);
      onItemChange("weight", selectedItem?.weight);
      onItemChange("totalQty", selectedItem?.totalQty);
      onItemChange("outsourcedItem", selectedItem?.outsourcedItem);
      onItemChange("outSourceItemlimit", selectedItem?.outSourceItemlimit);
      setCurrentIndex(0);
    },
    [onItemChange],
  );

  const handleQuantityChange = (e) => {
    const qty = Number(e.target.value);
    onItemChange("qty", qty);

    if (item.price) {
      onItemChange("amount", qty * item.price);
    }
  };

  const validateQuantity = (selectedItem, qty) => {
    const i = isEdit ? item : selectedItem;

    if (!i) {
      show("Please select a valid item first", "warning");
      return false;
    }

    const warnings = [];
    const isOutsourced = i?.outsourcedItem;

    if (!i?.itemNo) warnings.push(`Item Number cannot be empty`);
    if (!qty) warnings.push(`Quantity cannot be empty`);

    if (isOutsourced === "Disable" && Number(qty) > Number(i.totalQty)) {
      warnings.push(`Quantity exceeds available stock`);
    }

    if (isOutsourced === "Active" && qty > i.outSourceItemlimit) {
      warnings.push(`Quantity exceeds limit out source limit`);
    }

    if (warnings?.length > 0) {
      show(warnings, "warning");
      return false;
    }

    return true;
  };

  const handleQuantityKeyDown = (e) => {
    if (e.key === "-" || e.key === "e") {
      e.preventDefault();
    }

    if (e.key === "Enter") {
      e.preventDefault();

      if (validateQuantity(selectedItem, e.target.value)) {
        descToggle(true);
      }
    }
  };

  const descToggle = (value) => {
    setShowDescInput(value);
    if (onShowDesc) {
      onShowDesc(value);
    }
  };

  const handleDescChange = (e) => {
    setDescription(e.target.value);
  };

  const handleDescKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onItemChange("desc", description);
      descToggle(false);

      if (index === itemDetailsLength - 1) {
        onAddNewItem();
      } else {
        setShowItemSearch(false);
        setTimeout(() => {
          const nextInput = document.querySelector(
            `input[data-item-index="${index + 1}"]`,
          );

          if (nextInput) {
            nextInput.focus();
          }
        }, 50);
      }
    }
  };

  const handleItemKeyDown = (e) => {
    if (e.ctrlKey && e.key === "Backspace") {
      e.preventDefault();
      if (itemDetailsLength === 1) {
        show("YOU CANNOT REMOVE THE ONLY ITEM!", "warning");
        return;
      }
      onRemove(index);
      setTimeout(() => {
        if (index > 0) {
          const prevQuantityRef = quantityRefs.current[index - 1];
          if (prevQuantityRef) {
            prevQuantityRef.focus();
          }
        }
      }, 50);
    }
  };

  useEffect(() => {
    if (inputRef.current) {
      itemInpRefs(inputRef.current);
    }
  }, [itemInpRefs]);

  useEffect(() => {
    if (showDescInput && descInpRef.current) {
      descInpRef.current.focus();
    }
  }, [showDescInput]);

  useEffect(() => {
    if (item?.itemNo && item?.itemNo?.length > 2) {
      const timer = setTimeout(() => {
        fetchItems();
      }, 300);
      return () => clearTimeout(timer);
    } else {
      setResults([]);
    }
  }, [fetchItems, item?.itemNo]);

  useEffect(() => {
    const allValuesZeroOrEmpty = Object.values(item).every(
      (value) => value === 0 || value === "",
    );
    setIsEdit(!allValuesZeroOrEmpty);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (flag === "create") {
      setDescription("");
    }
  }, [flag]);

  return (
    <div
      style={{ display: "flex", flexDirection: "column" }}
      onKeyDown={handleItemKeyDown}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
        <li
          className={`${styles.p_table_row} ${
            mode ? styles.p_table_row_dark : ""
          }`}
        >
          <div className={styles.entry_2}>{index + 1}</div>

          <div className={styles.entry_2} style={{ overflow: "visible" }}>
            <div className={styles.inp_div} style={{ position: "relative" }}>
              <input
                ref={inputRef}
                data-item-index={index}
                type="text"
                placeholder="Search Item No"
                autoComplete={"new-password"}
                className={`${styles.item_inp} ${
                  mode ? styles.item_inp_dark : ""
                }`}
                value={item?.itemNo?.toUpperCase() || ""}
                onChange={handleInputChange}
                onKeyDown={handleKeyDown}
                onFocus={() => itemFocus(index)}
                onBlur={itemBlur}
              />

              {showItemSearch && focusedItemIndex === index && (
                <SearchItem
                  mode={mode}
                  results={results}
                  currentIndex={currentIndex}
                  loading={loading}
                  type={"sale"}
                  onItemSelect={(i) => {
                    if (results?.length > 0 && currentIndex >= 0) {
                      if (validateItem(i)) {
                        setSelectedItem(i);
                        setShowItemSearch(false);
                        handleItemSelect(i);
                        setTimeout(() => {
                          quantityRefs.current[index]?.focus();
                        }, 50);
                      }
                    } else {
                      inputRef.current?.blur();
                      setShowItemSearch(false);
                    }
                  }}
                />
              )}
            </div>
          </div>

          <div className={styles.entry_2}>{item.product_name || "-"}</div>
          <div className={styles.entry_2}>{item.collection_name || "-"}</div>

          {/* <div className={styles.entry_2}>{item.warehouse || "-"}</div> */}
          <div className={styles.entry_2}>
            <input
              ref={(el) => {
                if (el && quantityRefs.current) {
                  quantityRefs.current[index] = el;
                }
              }}
              type="number"
              min="0"
              step="1"
              placeholder="Qty"
              autoComplete={"new-password"}
              value={item.qty || ""}
              onChange={handleQuantityChange}
              onKeyDown={handleQuantityKeyDown}
              className={`${styles.item_inp} ${
                mode ? styles.item_inp_dark : {}
              }`}
            />
          </div>
          <div className={styles.entry_2}>{item.unit || "-"}</div>
          <div className={styles.entry_2}>
            {item?.price ? `${item?.price?.toFixed(2)}` : "-"}
          </div>

          <div className={styles.entry_2}>
            {flag === "create"
              ? item?.amount?.toFixed(2)
              : item?.price * item?.qty}
          </div>
        </li>

        {itemDetailsLength > 1 && (
          <div style={{ cursor: "pointer" }} onClick={onRemove}>
            <RemoveIcon />
          </div>
        )}
      </div>

      {(showDescInput || item?.desc?.length !== 0) && (
        <input
          type="text"
          placeholder="Enter description"
          value={description}
          onChange={handleDescChange}
          onKeyDown={handleDescKeyDown}
          onBlur={() => {
            onItemChange("desc", description);
            setShowDescInput(false);
          }}
          className={`${styles.item_inp} ${styles.desc} ${
            mode ? styles.item_inp_dark : ""
          }`}
          ref={descInpRef}
        />
      )}
    </div>
  );
};

export default ProductionSaleNewItemList;
